import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import NotificationsService from './services/NotificationsService'

export const getUserNotificationSettings = createAsyncThunk(
  'systemNotifications/getUserNotificationSettings',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.getUserNotificationSettings(
        data,
      )
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postUserNotificationSettings = createAsyncThunk(
  'systemNotifications/postUserNotificationSettings',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.postUserNotificationSettings(
        data,
      )
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getPaged = createAsyncThunk(
  'systemNotifications/getPaged',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.getPaged(data)
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const updateReadStatus = createAsyncThunk(
  'systemNotifications/updateReadStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.updateReadStatus(data)
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postMarkAllAsRead = createAsyncThunk(
  'systemNotifications/postMarkAllAsRead',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.postMarkAllAsRead(data)
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteNotifications = createAsyncThunk(
  'systemNotifications/deleteNotifications',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.deleteNotifications(data)
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
